import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import Swal from 'sweetalert2';
import EditDropdown from '../helperComponent/EditDropdown';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const UpdateNotes = () => {
  const [notesData, setNotesData] = useState([
    {
      title: '',
      price: '',
      offerPrice: '',
      description: '',
    },
  ]);
  const [formData, setFormData] = useState([]);
  const [image, setImage] = useState([]);
  const [i, setI] = useState(false);
  const [f, setF] = useState(false);
  const [sub, setSub] = useState([]);

  const handleChange = (e) => {
    setNotesData({ ...notesData, [e.target.name]: e.target.value });
  };

  // data
  const { id } = useParams();
  let history = useHistory();
  const btnStyle = {
    background: '#ffcc29',
    color: '#fff',
    border: 'none',
  };

  // data
  const uname = JSON.parse(localStorage.getItem('uname'));
  const AuthStr = process.env.REACT_APP_AUTH_STR;
  let fetchUrl = `https://stucharge.bakersbrisk.com/api/singlenotesapi?username=${uname}&id=${id}`;
  let URL = `https://stucharge.bakersbrisk.com/api/notesapi?username=${uname}&id=${id}`;

  // fetch data with the required id
  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(fetchUrl, {
        headers: { Authorization: AuthStr },
      });
      if (result.status === 200) {
        setNotesData(result.data);
      } else {
        toast.error('Something went wrong!');
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // File data
  const handleUpload = (e) => {
    e.preventDefault();
    const file = e.target.files;
    setF(true);
    setFormData(file[0]);
  };

  // Image upload
  const handleImageUpload = (e) => {
    e.preventDefault();
    setI(true);
    const file = e.target.files;
    setImage(file[0]);
  };

  // handle offer price
  const handleOfferPrice = (e) => {
    const op = e.target.value;
    if (op < 0) {
      setNotesData({ ...notesData, [e.target.name]: 0 });
    } else if (parseInt(op, 10) > parseInt(notesData.price, 10)) {
      setNotesData({ ...notesData, [e.target.name]: notesData.price });
    } else {
      setNotesData({ ...notesData, [e.target.name]: e.target.value });
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    // Fire confirmation
    Swal.fire({
      title: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        updateNotes();
      } else if (result.isDenied) {
        Swal.fire('Notes not updated!', '', 'info');
      }
    });
  };

  var bodyFormData = new FormData();
  async function updateNotes() {
    if (f) {
      bodyFormData.append('pdf', formData);
    }
    if (i) {
      bodyFormData.append('cover_image', image);
    }
    bodyFormData.append('title', notesData.title);
    bodyFormData.append('price', notesData.price);
    bodyFormData.append('offer_price', notesData.offer_price);
    bodyFormData.append('description', notesData.description);
    bodyFormData.append('subject', sub);
    notesData.subject = sub;
    bodyFormData.append('subject', notesData.subject);

    const requestOptions = {
      method: 'PUT',
      headers: { Authorization: AuthStr },
      body: bodyFormData,
    };
    fetch(URL, requestOptions)
      .then(async (response) => {
        const data = await response.json();
        // check for error response
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        Swal.fire('Notes updated successfully', '', 'success').then(
          (result) => {
            if (result.isConfirmed || !result.isConfirmed) {
              history.push('/home');
              history.push('/notes');
            }
          }
        );
      })
      .catch((error) => {
        Swal.fire('Error updating notes', '', 'error');
      });
  }

  return (
    <div className='main_container'>
      <div className='alert-heading'>
        <h1>Update Notes Details</h1>
      </div>
      <form onSubmit={(e) => submitHandler(e)} className='class-form'>
        <div className='form-control'>
          <label htmlFor='title'>Notes Title</label>
          <input
            type='text'
            value={notesData.title || ''}
            required
            name='title'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='item'>Description</label>
          <textarea
            className='update-detail'
            type='text'
            value={notesData.description || ''}
            required
            name='description'
            onChange={(e) => handleChange(e)}
          ></textarea>
        </div>
        <div className='form-control'>
          <label htmlFor='subject'>Subject</label>
          <EditDropdown
            setSub={setSub}
            value={notesData.subject ? notesData.subject.name : 'Select'}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='price'>Price</label>
          <input
            type='number'
            value={notesData.price || 0}
            required
            name='price'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='offerPrice'>Offer Price</label>
          <input
            type='number'
            value={notesData.offer_price || 0}
            required
            name='offer_price'
            onChange={(e) => handleOfferPrice(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='image'>Update Cover Image</label>
          <input
            type='file'
            name='image'
            accept='image/x-png,image/gif,image/jpeg'
            onChange={(e) => handleImageUpload(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='file'>Update File</label>
          <input
            type='file'
            name='formData'
            accept='application/pdf'
            onChange={(e) => handleUpload(e)}
          />
        </div>
        <button type='submit' className='btn' style={btnStyle}>
          Update Notes
        </button>
      </form>
    </div>
  );
};

export default UpdateNotes;
